import { ChangeDetectionStrategy, Component, computed, Inject, OnDestroy, OnInit, signal } from "@angular/core";
import { CurrencyType } from "@soposopo/sopo-models";

import {
    composeRingPointMessage,
    composeRingPointTitle,
    DEFAULT_NECESSARY_POINTS,
    DEFAULT_RING_POINT_RESET_FREQUENCY,
    RingPointResetFrequency,
} from "src/app/shared/utils/ring-points.utils";
import { SOPO_DIALOG_DATA, SopoDialogRef } from "src/app/sopo-popup/interfaces/dialog";

@Component({
    selector: 'app-daily-ring-points',
    templateUrl: './daily-ring-points.component.html',
    styleUrls: ['./daily-ring-points.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class DailyRingPointsComponent implements OnInit, OnDestroy {
    necessaryPoints = signal<number>(DEFAULT_NECESSARY_POINTS);
    currentPoints = signal<number>(0);
    selectedCurrency = signal<CurrencyType>(CurrencyType.SWEEPBUCK);
    frequency = signal<RingPointResetFrequency>(DEFAULT_RING_POINT_RESET_FREQUENCY);

    title = computed(() => composeRingPointTitle(this.frequency()));
    message = computed(() =>
        composeRingPointMessage(this.frequency(), this.selectedCurrency())
    );

    constructor(
        private sopoDialogRef: SopoDialogRef,
        @Inject(SOPO_DIALOG_DATA) private data: {
            necessaryPoints: number,
            currentPoints: number,
            currency: CurrencyType,
            frequency?: RingPointResetFrequency,
        },
    ) {}

    ngOnInit(): void {
        if (!isNaN(this.data?.necessaryPoints)) this.necessaryPoints.set(this.data.necessaryPoints);
        if (!isNaN(this.data?.currentPoints)) this.currentPoints.set(this.data.currentPoints);
        if (this.data.currency) this.selectedCurrency.set(this.data.currency);
        if (this.data.frequency) this.frequency.set(this.data.frequency);
    }

    close() {
        this.sopoDialogRef.close();
    }

    ngOnDestroy(): void {}
}
